import axios from 'axios';
import environment from '@src/environment';
import optimizeCloudinaryUrl from '@src/utils/cloudinary-optimizations';

export const state = {
  platelist: [],
  platelistDays: {},
  appliedPlatelist: null,
  selectedPlatelist: null,
};

export const getters = {};

export const mutations = {
  setPlatelist(state, value) {
    state.platelist = value;
  },
  setPlatelistDays(state, { daysData, id }) {
    const platelistDaysClone = _.cloneDeep(state.platelistDays);
    platelistDaysClone[id] = daysData;
    state.platelistDays = platelistDaysClone;
  },
  setAppliedPlatelist(state, value) {
    state.appliedPlatelist = value;
  },
  handleError(state, newValue) {
    this.state.errors.serverError = newValue;
  },
  setSelectedPlatelist(state, value) {
    state.selectedPlatelist = value;
  },
  setUpdatePlatelistLockStatus(state, value) {
    const selectedPlatelistClone = _.cloneDeep(state.selectedPlatelist);
    selectedPlatelistClone.contentLockStatus = {
      ...selectedPlatelistClone.contentLockStatus,
      locked: false,
      unlockDate: value.created,
    };
    state.selectedPlatelist = selectedPlatelistClone;
  },
};

export const actions = {
  async getPlatelist(ctx, { categorized } = {}) {
    const params = categorized ? '/categorized' : '';

    return await axios
      .get(`${environment.PLATELIST_DISCOVERY_URL}${params}`)
      .then((res) => {
        res.data.map((plan) => {
          plan.imageurl = optimizeCloudinaryUrl(plan.imageurl);
          plan.mobileheroimageurl = optimizeCloudinaryUrl(plan.mobileheroimageurl);
          return plan;
        });
        return ctx.commit('setPlatelist', res.data);
      })
      .catch((err) => console.log(err));
  },
  async getPlatelistDays(ctx, id) {
    if (!ctx.state.platelistDays[id]) {
      return await axios
        .get(`${environment.PLATELIST_DAYS_URL.replace(':id', id)}`)
        .then((res) => {
          res.data.forEach((platelist) =>
            platelist.recipes.map((recipe) => {
              recipe.imageURL = optimizeCloudinaryUrl(recipe.imageURL);
              return recipe;
            })
          );
          return ctx.commit('setPlatelistDays', { daysData: res.data, id: id });
        })
        .catch((err) => console.log(err));
    }
  },
  async getPublicPlatelistSummary(ctx, id) {
    return await axios
      .get(`${environment.PUBLIC_PLATELIST_SUMMARY.replace(':id', id)}`)
      .then((res) => {
        ctx.commit('setPlatelistDays', { daysData: res.data.platelistDays, id: id });
        return res.data;
      })
      .catch((err) => console.log(err));
  },
  async applyPlatelist(ctx, { payload, title }) {
    return await axios
      .post(`${environment.PLATELIST_APPLY_URL}`, payload)
      .then((res) => {
        ctx.commit('setAppliedPlatelist', { ...payload, title });
        return res.data;
      })
      .catch((err) => {
        err.retry.enabled = true;
        ctx.commit('handleError', err);
        console.log(err);
      });
  },

  async unlockPlatelist(ctx, id) {
    return await axios
      .put(`${environment.PLATELIST_UNLOCK_URL.replace(':id', id)}`)
      .then((res) => res.data)
      .catch((err) => {
        err.retry.enabled = true;
        ctx.commit('handleError', err);
        console.log(err);
      });
  },
};
